import React from 'react';

const InvisiblePane = (props) => {
    return (
        <div className={'application-invisible-pane'} style={!!props && !!props.style ? props.style : {}}>
            {props.children}
        </div>
    );
}

export default InvisiblePane;
